import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const ProfileDataThunk = createAsyncThunk(
	"ProfileData/ProfileDataThunk",
	async (_, ThunkApi) => {
		let { rejectWithValue } = ThunkApi;
		try {
			let res = await axios.get(`auth/profile`);

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data?.data);
		}
	}
);
